<app-dark-back-button *ngIf="showBackButton$ | async" (backClicked)="goBack()" [paddingBottomRem]="2" />
<ng-container [ngSwitch]="authFlow$ | async">
  <!--  Sign In Flow  -->
  <ng-container *ngSwitchCase="EmployerAuthFlow.SignIn">
    <app-sign-in (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Forgot Password Flow  -->
  <ng-container *ngSwitchCase="EmployerAuthFlow.ForgotPassword">
    <app-forgot-password (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Reset Password Flow  -->
  <ng-container *ngSwitchCase="EmployerAuthFlow.ResetPassword">
    <app-reset-password (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  New Password Flow  -->
  <ng-container *ngSwitchCase="EmployerAuthFlow.EmployerChoosePassword">
    <app-employer-choose-password />
  </ng-container>
  <!--  Enter MFA Code Flow  -->
  <ng-container *ngSwitchCase="EmployerAuthFlow.EmployerMFAVerification">
    <app-verify-mfa (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
</ng-container>
